import React from 'react';

import SubmissionMedia from './SubmissionMedia';


function SubmissionDetails({
    submission,
}) {
    const uploadDate = new Date(submission["submittedTime"].seconds * 1000);

    // Note, "itemDesc" comes from SummaryDetails hijacking setCurSubDetails to add the item
    // name
    // playerName is injected by SummaryTable; falls back to the raw ref id
    // (which is a uid for new submissions, a name for legacy ones).
    const who = submission["playerName"] ?? submission["player"].id;
    return <div>
        <h4>{who}'s submission for "{submission["itemDesc"]}" </h4>
        <SubmissionMedia submission={submission} height={420} style={{ maxWidth: 480 }} />
        <p>Uploaded at {uploadDate.toLocaleString()}</p>
    </div>
}

export default SubmissionDetails;